"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZillowHomeLogo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ZillowHomeLogo = require("./ZillowHomeLogo.styles");
var _excluded = ["removeTrademark"];
/**
 * Displays only the home symbol. The same sizing and color guidelines for `ZillowLogo` apply.
 *
 * @since 7.23.0
 */
var ZillowHomeLogo = function ZillowHomeLogo(_ref) {
  var removeTrademark = _ref.removeTrademark,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var trademark;
  if (!removeTrademark) {
    trademark = /*#__PURE__*/_react.default.createElement("path", {
      d: "M397.7 372.4h6.6l6.2 18.1 6.3-18h6.6v25h-4v-20.6l-7 20.6h-3.6l-7-20.6v20.6h-4zm-4 0v3.7h-6.2v21.4h-4V376h-6v-3.7z"
    });
  }
  return /*#__PURE__*/_react.default.createElement(_ZillowHomeLogo.StyledZillowHomeLogo, (0, _extends2.default)({
    viewBox: "0 0 " + (removeTrademark ? 364 : 423.4) + " 400"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M246.2 107.8c1.8-.4 2.7.2 3.8 1.5 6.2 7 26.4 31.6 31.9 38.3a2.1 2.1 0 0 1-.5 3.2 727.8 727.8 0 0 0-111.1 108.8c-.6.7-.1.8.2.6 44-18.9 147.1-49 193.7-57.5v-58.9L182.2 0 0 143.8v64.3c56.5-33.5 187-85.5 246.2-100.3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M98.2 355.2a3 3 0 0 1-4-.6l-34-40.5c-1-1-1-1.7.2-3.4 26.2-38.5 79.8-98.4 114-123.8.6-.4.4-.9-.3-.6-35.5 11.6-136.7 55-174.1 76.2V400h364.2V267.7c-49.8 8.4-198.4 52.7-266 87.5z"
  }), trademark));
};
exports.ZillowHomeLogo = ZillowHomeLogo;
ZillowHomeLogo.displayName = 'ZillowHomeLogo';
ZillowHomeLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The token color of the logo.
   */
  fontColor: _propTypes.default.string,
  /**
   * Zillow logos should **always include the trademark** unless you verify with the brand team
   * that it can be removed.
   */
  removeTrademark: _propTypes.default.bool
} : {};
ZillowHomeLogo.defaultProps = {
  fontColor: 'brand',
  removeTrademark: false
};